module.exports = __webpack_public_path__ + "img/9.27e431bf.jpg";